'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const Formatters=require('../../../dist-es6/client/formatters');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const CalendarDay=require('pulsar-utils/dist-es6/time/calendarDay');
const CalendarRange=require('pulsar-utils/dist-es6/time/calendarRange');
const ErrorMessages=require('../../../dist-es6/client/errorMessages');
const TimeSeries=require('pulsar-dashboard-core/dist-es6/utilities/timeSeries');
const ae=require('../../../dist-es6/shared/extensions/assessmentsExtensions');

const _DutyTruncationPoint=timespan.fromHours(8).totalMilliseconds();
const _MaxDifferenceBetweenEndOfScheduleAndNow=timespan.fromMinutes(30).totalMilliseconds();let

PersonalScheduleDataService=class PersonalScheduleDataService extends BaseService{
constructor(personService,
notificationService,
scheduleService,
statisticsService,
rasterizationService,
personalFatigueThresholdService,
personalIncidentsService,
userService,
fatigueMeterTypeContentProviderService,
timeFormattingService){
super();

this._personService=personService;
this._notificationService=notificationService;
this._scheduleService=scheduleService;
this._statisticsService=statisticsService;
this._rasterizationService=rasterizationService;
this._personalFatigueThresholdService=personalFatigueThresholdService;
this._personalIncidentsService=personalIncidentsService;
this._userService=userService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;
this._timeFormattingService=timeFormattingService;
}

get _fatigueMeterType(){
return _.get(this._userService,'currentUser.fatigueMeterType');
}

async tryGetPersonInfoAndWeeksInQueryInterval({id:personId,employeeId}={},queryInterval,timezone){
_.ensureInstanceOf('string',personId,{nullable:!0});
_.ensureInstanceOf('string',employeeId,{nullable:!0});
_.ensureInstanceOf(TimeInterval,queryInterval);
_.ensureInstanceOf('string',timezone,{nullable:!0});

const personIdentifier=_.exists(employeeId)?`employeeId=${encodeURIComponent(employeeId)}`:personId;
const personInfoResponse=await this._personService.getPersonInfoFor(personIdentifier,queryInterval.isPoint());

if(personInfoResponse.status!=='Ok'){
const message=personInfoResponse.status==='NotFound'?
`${this._fatigueMeterTypeContentProviderService.personTypeLabelSingular} not found in current organization.`:
ErrorMessages.OopsTryAgain;

this._notificationService.displayNotification(message,'error');
return{error:personInfoResponse.status};
}

const personInfo=personInfoResponse.body;


const weeksInQueryInterval=PersonalScheduleDataService.getWeeksForQueryInterval(queryInterval,timezone||personInfo.homeTimezone,personInfo.predictedWorkday);

return{personInfo,weeksInQueryInterval};
}

async getScheduleDataFor(personInfo,weeks,timezone){
_.ensureInstanceOf(Object,personInfo);
_.ensureInstanceOf('string',personInfo.id);
_.ensureInstanceOf('string',personInfo.homeTimezone);
_.ensureArrayOf(TimeInterval,weeks);

let{fatigueThreshold,deviationThreshold,groupMemberships}=await this._personalFatigueThresholdService.getTresholdAndGroupInfoFor(personInfo.id);

let weekSectionModels=await Promise.all(weeks.map(w=>this._loadDataForWeek(personInfo,timezone,w,fatigueThreshold,deviationThreshold,groupMemberships)));
let now=_.get(weekSectionModels[0],'personalSchedule.now');
let timeOfLastScheduleUpdate=_.get(weekSectionModels[0],'personalStatistics.lastKnownStatus.time');

if(_.exists(timeOfLastScheduleUpdate)&&!_.isDate(timeOfLastScheduleUpdate)){
timeOfLastScheduleUpdate=new Date(timeOfLastScheduleUpdate);
}

let timeOfLastHosStatus=_.get(weekSectionModels[0],'personalStatistics.timeOfLastHosStatus');
let invalidDataWarning=this._getInvalidDataWarning({personInfo,now,timeOfLastScheduleUpdate,timeOfLastHosStatus,timezone});
let predictedWorkday=_.get(_.findLast(weekSectionModels,m=>m.personalSchedule.predictedWorkday),'personalSchedule.predictedWorkday');
let forecastDutyInterval=_.get(_.findLast(weekSectionModels,m=>m.personalSchedule.forecastDutyInterval),'personalSchedule.forecastDutyInterval');
let displayTimeZone=this.getDisplayTimeZoneFor(_.get(weekSectionModels,'0.dailySchedules'),timezone);



const rawEstimateAsOfTime=_.get(weekSectionModels[0],'personalSchedule.estimatesAsOfTime');
const estimatesAsOfTime=_([timeOfLastScheduleUpdate,rawEstimateAsOfTime]).compact().max(d=>d.getTime());

return{
weekSectionModels,
now,
timeOfLastScheduleUpdate,
timeOfLastHosStatus,
invalidDataWarning,
predictedWorkday,
forecastDutyInterval,
estimatesAsOfTime,
fatigueThreshold,
deviationThreshold,
groupMemberships,
displayTimeZone};

}

async _loadDataForWeek(personInfo,timezone,weekInterval,fatigueThreshold,deviationThreshold,groupMemberships){

let[personalSchedule,personalStatistics]=await Promise.all([
this._scheduleService.getScheduleFor(personInfo,weekInterval,timezone),
this._statisticsService.getPersonalStatisticsFor(personInfo,weekInterval,timezone)]);



const endOfSchedule=_.get(personalSchedule,'bounds.end');
if(_.exists(endOfSchedule)){

if(personalSchedule.fatigue.length>0){
const endPoint=TimeSeries.getInterpolatedPointAtTime(personalSchedule.fatigue,endOfSchedule);
const endTime=endPoint.time.getTime();
personalSchedule.fatigue=_.takeWhile(personalSchedule.fatigue,p=>p.time.getTime()<endTime).concat(endPoint);
}

const{predictedWorkday}=personalSchedule;
const pastFutureSplit=personalStatistics.currentStatusSource==='effectiveStatus'?_.get(personalStatistics,'lastKnownStatus.time'):endOfSchedule;

if(predictedWorkday&&pastFutureSplit&&predictedWorkday.end.getTime()>pastFutureSplit.getTime()){
personalSchedule.forecastDutyInterval=TimeInterval.from(pastFutureSplit).to(predictedWorkday.end);
}

if(personalSchedule.forecastDutyInterval&&_.get(personalSchedule,'forecastFatigue.length',0)>0){
const startPoint=TimeSeries.getInterpolatedPointAtTime(personalSchedule.forecastFatigue,personalSchedule.forecastDutyInterval.start);
const endPoint=TimeSeries.getInterpolatedPointAtTime(personalSchedule.forecastFatigue,personalSchedule.forecastDutyInterval.end);
const startTime=startPoint.time.getTime();
const endTime=endPoint.time.getTime();

const filteredForecastFatigue=[startPoint].
concat(_(personalSchedule.forecastFatigue).
skipWhile(p=>p.time.getTime()<=startTime).
takeWhile(p=>p.time.getTime()<endTime).
value()).
concat([endPoint]);

if(personalStatistics.currentStatusSource==='effectiveStatus'){
const lastForecastFatigueTime=_.last(filteredForecastFatigue).time.getTime();
const beforeForecast=_.takeWhile(personalSchedule.fatigue,p=>p.time.getTime()<=pastFutureSplit.getTime());
const afterForecast=_.dropWhile(personalSchedule.fatigue,p=>p.time.getTime()<=lastForecastFatigueTime);
personalSchedule.fatigue=beforeForecast.concat(filteredForecastFatigue).concat(afterForecast);
}else{
personalSchedule.fatigue=personalSchedule.fatigue.concat(filteredForecastFatigue);
}
}


if(this._fatigueMeterTypeContentProviderService.alertsSource==='assessments'){
personalSchedule.pastShifts=ae.getPastShifts({shifts:ae(personalSchedule.assessments).asShifts(),currentShift:predictedWorkday,now:pastFutureSplit});
}


const clipInterval=TimeInterval.from(pulsarDate.MinDate()).to(endOfSchedule);
const clippedSleep=TimeInterval.clip(personalSchedule.sleep).to(clipInterval);
for(const[original,clipped]of _.zip(personalSchedule.sleep,clippedSleep)){
if(!clipped){
break;
}
clipped.startTimezone=original.startTimezone;
clipped.endTimezone=original.end.getTime()===clipped.end.getTime()?original.endTimezone:original.startTimezone;
}
personalSchedule.sleep=clippedSleep;
}else{
personalSchedule.fatigue=[];
personalSchedule.sleep=[];
}



if(this._fatigueMeterTypeContentProviderService.alertsSource==='assessments'){
personalSchedule.sleep=[];
}

let dailySchedules=this._rasterizationService.rasterize(personalSchedule,weekInterval,'days',timezone);

this._attachThresholdStatusesToDailyFatigueSummaries(personalStatistics.dailyFatigueSummaries,fatigueThreshold);
this.attachThresholdStatusesDevationAndTimezoneToIncidents(personalSchedule.incidents,fatigueThreshold,deviationThreshold,timezone);
for(const schedule of dailySchedules){
if(!schedule.incidents||schedule.incidents.length===0){
continue;
}

this.attachThresholdStatusesDevationAndTimezoneToIncidents(schedule.incidents,fatigueThreshold,deviationThreshold,timezone,groupMemberships);
}
this.attachEffectiveThresholdsToDailySchedules(personalSchedule,dailySchedules,fatigueThreshold,deviationThreshold,timezone);

return{personalStatistics,personalSchedule,dailySchedules,fatigueThreshold};
}

attachEffectiveThresholdsToDailySchedules(personalSchedule,dailySchedules,fatigueThreshold,deviationThreshold){
personalSchedule.effectiveThresholds=personalSchedule.dailyEffectiveStatuses.map(effectiveStatus=>{
return ThresholdStatus.getEffectiveThresholds({
fatigueThreshold,
deviationThresholdDay:deviationThreshold,
fatigueHistory:_.get(effectiveStatus,'statistics.recentHistory.fatigue',null)}).
get(this._fatigueMeterTypeContentProviderService.visualNotificationType);
});

for(let dayIndex in personalSchedule.effectiveThresholds){
dailySchedules[dayIndex].effectiveThreshold=personalSchedule.effectiveThresholds[dayIndex];
}
}

_attachThresholdStatusesToDailyFatigueSummaries(dailyFatigueSummaries,fatigueThreshold){
for(let dayIndex in dailyFatigueSummaries){
let maxFatigueOnDuty=_.get(dailyFatigueSummaries[dayIndex],`maxFatigueOnDuty`);
let averageFatigueOnDuty=_.get(dailyFatigueSummaries[dayIndex],`averageFatigueOnDuty`);

dailyFatigueSummaries[dayIndex].maxFatigueOnDuty={
value:maxFatigueOnDuty,
thresholdStatus:this.getThresholdStatus(maxFatigueOnDuty,fatigueThreshold)};

dailyFatigueSummaries[dayIndex].averageFatigueOnDuty={
value:averageFatigueOnDuty,
thresholdStatus:this.getThresholdStatus(averageFatigueOnDuty,fatigueThreshold)};

}
}

attachThresholdStatusesDevationAndTimezoneToIncidents(incidents,fatigueThreshold,deviationThreshold,timezone,groupMemberships){


for(const incident of incidents){
const recentHistoryFatigue=_.get(incident.statistics,'recentHistory.fatigue');
_.assign(incident,{
fatigueThresholdStatus:ThresholdStatus.fromScoreAndThreshold(incident.fatigue,fatigueThreshold),
deviationThresholdStatus:ThresholdStatus.fromFatigueDeviation(incident.fatigue,recentHistoryFatigue,deviationThreshold),
deviation:ThresholdStatus.getDeviationFrom(incident.fatigue,recentHistoryFatigue,deviationThreshold),
currentlyScopedGroupMemberships:groupMemberships,
incident});

}
}

static getWeeksForQueryInterval(queryInterval,timezone,predictedWorkday){
const startDay=CalendarDay.calendarDayFor({time:queryInterval.start,timezone});
const endDay=CalendarDay.calendarDayFor({time:queryInterval.isPoint()?queryInterval.end:new Date(queryInterval.end.getTime()-1),timezone});
const range=new CalendarRange(startDay,endDay);
const remainder=range.totalDays%7;
const roundedStartDay=remainder==0?startDay:startDay.plusDays(-(7-remainder));

const weeks=[];
const totalDays=new CalendarRange(roundedStartDay,endDay).totalDays;

for(let dayOffset=0;dayOffset<totalDays;dayOffset+=7){
weeks.push(new CalendarRange(roundedStartDay.plusDays(dayOffset),roundedStartDay.plusDays(dayOffset+6)).asExpandedTimeInterval(timezone));
}

if(queryInterval.isPoint()&&predictedWorkday&&weeks[0].contains(predictedWorkday.start)&&!weeks[0].contains(predictedWorkday.end)){

const weekContainingPredictionEnd=PersonalScheduleDataService.getWeeksForQueryInterval(TimeInterval.fromPoint(predictedWorkday.end),timezone)[0];
if(weekContainingPredictionEnd.contains(queryInterval.start)){
weeks[0]=weekContainingPredictionEnd;
}
}

return weeks;
}

getThresholdStatus(fatigueValue,fatigueThreshold){
return _.allExist(fatigueValue,fatigueThreshold)?
ThresholdStatus.fromScoreAndThreshold(fatigueValue,fatigueThreshold):
ThresholdStatus.NotApplicable;
}

getDisplayTimeZoneFor(dailySchedules,timezone){
_.ensureInstanceOf(Array,dailySchedules);
_.ensureInstanceOf('string',timezone);

let endOfSundayTime=_.get(dailySchedules,'0.interval.end');
if(!_.allExist(timezone,endOfSundayTime)){
return null;
}


return Formatters.formatInLocale(endOfSundayTime,'',timezone,{displayTimeZone:!0});
}

async getAllIncidentsFor(personId){
_.ensureInstanceOf('string',personId,{nullable:!0});

return await this._personalIncidentsService.getAllIncidentsFor(personId);
}

_getInvalidDataWarning({personInfo,now,timeOfLastScheduleUpdate,timeOfLastHosStatus,timezone}){
if(personInfo.activationStatus.value!=='activated'){
return`Deactivated ${this._timeFormattingService.timeAndFullDateInTimezone(personInfo.activationStatus.timeChanged,timezone)}.`;
}

if(_.exists(timeOfLastScheduleUpdate)&&_.exists(timeOfLastHosStatus)){
if(timeOfLastScheduleUpdate.getTime()-timeOfLastHosStatus.getTime()===_DutyTruncationPoint){

return`Check logs — Stuck on duty since ${this._timeFormattingService.timeAndFullDateInTimezone(timeOfLastHosStatus,timezone)}.`;
}
if(now.getTime()-timeOfLastScheduleUpdate.getTime()>_MaxDifferenceBetweenEndOfScheduleAndNow){
return`Last updated ${this._timeFormattingService.timeAndFullDateInTimezone(timeOfLastScheduleUpdate,timezone)}.`;
}
}

return void 0;
}};


module.exports=PersonalScheduleDataService;
//# sourceMappingURL=personalScheduleDataService.js.map
